import React from 'react';
import Button from './Button';

/**
 * Lightweight page-level back control. Defaults to ghost/small so it stays tertiary
 * vs primary CTAs. Use hideOnDesktop when breadcrumb covers the same destination.
 */
const BackButton = ({
  onClick,
  children,
  className = '',
  variant = 'ghost',
  size = 'small',
  hideOnDesktop = false,
  ...props
}) => {
  const layoutClass = hideOnDesktop
    ? 'md:hidden -ml-1 px-1 sm:px-2 min-h-[36px] sm:min-h-0'
    : '-ml-1 px-1 sm:px-2';

  return (
    <Button
      onClick={onClick}
      variant={variant}
      size={size}
      className={`${layoutClass} ${className}`.trim()}
      type="button"
      {...props}
    >
      <svg className="mr-1.5 h-4 w-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      {children}
    </Button>
  );
};

export default BackButton;
